import React, { useEffect } from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  Box,
  Checkbox,
  FormControl,
  Input,
  ListItemText,
  MenuItem,
  Select,
} from "@material-ui/core";
import { IsMobile } from "utils/is-mobile";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: "fit-content",
    },
  },
};

function getStyles(option, selectedOptions, theme) {
  return {
    fontWeight: selectedOptions.some(
      (selectedOption) => selectedOption.Id === option.Id
    )
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "-0.5rem",
  };
}

export default function MultipleSelect({
  inputLabel,
  options,
  initialSelected,
  onSelectedChange,
  variant,
}) {
  const [selectedOptions, setSelectedOptions] = React.useState(
    initialSelected || []
  );
  const theme = useTheme();

  const isMobile = IsMobile();

  const handleChange = (event) => {
    setSelectedOptions(event.target.value);
  };

  useEffect(() => {
    onSelectedChange(selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);

  return (
    <FormControl
      variant={variant}
      component={Box}
      width="100%"
      marginBottom="1.5rem!important"
    >
      <Select
        id="multiple-checkbox"
        placeholder={inputLabel}
        multiple
        value={selectedOptions}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) =>
          selected?.map((option) => {
            return (
              <p
                key={option.Cnpj}
                style={{
                  fontSize: "0.85rem",
                  fontWeight: "500",
                  marginBottom: "-0.005rem",
                  paddingBottom: isMobile ? "0.45rem" : 0,
                  overflowX: "auto",
                }}
              >
                {option.Nome}
              </p>
            );
          })
        }
        MenuProps={MenuProps}
        variant={variant}
      >
        {options?.map((option) => (
          <MenuItem
            key={option.Cnpj}
            value={option}
            style={getStyles(option, selectedOptions, theme)}
            disabled={initialSelected[0]?.Cnpj === option.Cnpj}
          >
            <Checkbox
              style={{ marginLeft: "-1rem" }}
              checked={selectedOptions.some(
                (selected) => selected.Cnpj === option.Cnpj
              )}
              color="primary"
            />
            <ListItemText
              disableTypography
              primary={option.Nome}
              style={{
                fontSize: isMobile ? "0.8rem" : "0.95rem",
                fontWeight: "600",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
